// extracted by mini-css-extract-plugin
module.exports = {"mainCon":"main_mainCon__3_sBr"};